import useCheckPermission from "@/Hooks/useCheckPermission";

interface PermissionWrapperProps {
  permission: "view" | "update" | "delete" | "create";
  children: React.ReactNode;
}

const PermissionWrapper = ({
  children,
  permission,
}: PermissionWrapperProps) => {
  const { authService, hasPermission } = useCheckPermission();

  if (authService.isLoading) return <></>;

  if (hasPermission[permission]) {
    return <div>{children}</div>;
  }
};

export default PermissionWrapper;
